import type { ProductConfig } from '#types/config/components/product'

export default 'https://assets.vans.com/images/t_Thumbnail/na/not-available.png' satisfies ProductConfig['defaultImageUrl']
